module.exports = __webpack_public_path__ + "static/15-1-13709ab7af0402adb3b1f0d9f587af7e.jpg";